import type { SVGProps } from 'react'

export default function ChevronRightSmall(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M2 4L6 8L2 12" stroke="currentColor" />
		</svg>
	)
}
